export const API_URL = "https://arclif-backend.appspot.com/api"
export const SIGN_UP_USER_URL = "user"
export const SIGN_IN_USER_URL = "user/login"
export const GET_SUGGESTED_USERS_URL = "user-suggestions"
export const GET_USER_URL = "user"
export const CREATE_POST_URL = "post"
export const GET_POST_URL = "post"
export const GET_PROFILE_URL = "profile"
export const CREATE_COMMENT = "comment"
